var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-detail" },
    [
      _c(
        "el-row",
        { staticStyle: { margin: "16px 0" }, attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            _vm._l(_vm.tabs, function (item) {
              return _c(
                "el-button",
                {
                  key: item.value,
                  attrs: {
                    type: _vm.activeTab === item.value ? "primary" : "",
                  },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = item.value
                    },
                  },
                },
                [_vm._v(" " + _vm._s(item.name) + " ")]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c("keep-alive", [_c("tab-" + _vm.activeTab, { tag: "component" })], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }